import React from 'react';
import { Button, Modal } from '@roo/roo';
import { useHistory } from 'react-router-dom';
import { useSimpleContext } from '../_context';
import { submitInnovate } from '../../../assets/apis/innovate';
import { submitScientist } from '../../../assets/apis/scientist';
import { toastTip } from './ToastTip';
import { useStep } from '../_context/useData';

export function useFormSave() {
  const { state, update } = useSimpleContext((s) => [s.saving, s.handleSave, s.validateFields, s.values, s.disabled]);
  const { validateFields, handleSave: save, values } = state;
  const { setStep, step } = useStep();

  function handleSave({
    valid = false, tip = true, loading = true, onSaving,
  }) {
    if (state.isViewType || state.disabled) {
      return Promise.resolve(true);
    }
    if (loading) {
      update((t) => (t.saving = true));
    }
    if (step === 3 && window.GreenFileKey) {
      values.researchOverviewFileKeyMap = window.GreenFileKey;
    }
    if (!valid) {
      validateFields();
      return new Promise((resolve) => {
        save(state.values)
          .then(() => {
            if (tip) {
              toastTip.open({ title: '保存成功', content: '数据已成功保存', status: 'success' });
            }
            resolve();
          })
          .catch(() => {
            if (tip) {
              toastTip.open({ title: '保存失败', content: '请检查填写的数据', status: 'fail' });
            }
          })
          .finally(() => {
            update((s) => {
              s.saving = false;
              s.hasSave = true;
              s.hasChange = false;
            });
          });
        if (onSaving) {
          onSaving();
        }
      });
    }

    return new Promise((resolve, reject) => {
      validateFields((error, fields) => {
        if (valid && error) {
          reject();
          update((t) => (t.saving = false));
          return;
        }

        save(values)
          .then((res) => {
            if (tip) {
              toastTip.open({ title: '保存成功', content: '数据已成功保存', status: 'success' });
            }
            resolve();
          })
          .catch((e) => {
            if (tip) {
              toastTip.open({ title: '保存失败', content: '请检查填写的数据', status: 'fail' });
            }
          })
          .finally(() => {
            update((s) => {
              s.saving = false;
              s.hasSave = true;
            });
          });
        if (onSaving) {
          onSaving();
        }
      });
    });
  }

  const { saving } = state;
  return {
    saving, handleSave, setStep, step, validateFields, values,
  };
}

function editorContentIsEmpty(content) {
  // p | li | h2 | h3 | h4;
  return content === '<p><br></p>' || content === '<li><br></li>' || content === '<h2><br></h2>' || content === '<h3><br></h3>' || content === '<h4><br></h4>';
}

export function Footer() {
  const history = useHistory();
  const { state, update } = useSimpleContext((s) => [s.saving, s.handleSave, s.validateFields, s.values, s.disabled]);
  const {
    handleSave, setStep, step, saving,
  } = useFormSave();
  return (
    <div className={`form-plus form-footer ${state.isViewType ? '' : 'form-btn-x'}`} style={{ zIndex: 400 }}>
      {step > 1 && (
        <Button
          size="large"
          auto={false}
          type="hollow"
          loading={saving}
          onClick={() => {
            if (state.isViewType || state.hasSubmit) {
              return setStep(step - 1);
            }
            handleSave({ valid: false }).then((r) => {
              setStep(step - 1);
            });
          }}
        >
          上一页
        </Button>
      )}
      {step === 3 && (
        <>
          &nbsp;&nbsp;&nbsp;
          {/* <Link to={`/preview?formType=${state.formType}`} style={{ color: "#3F4156" }}> */}
          <Button
            size="large"
            auto={false}
            type="hollow"
            loading={saving}
            onClick={() => {
              handleSave({ valid: false, tip: false }).then(() => {
                history.push({
                  pathname: '/preview',
                  search: `formType=${state.formType || 'scientist'}`,
                });
              });
            }}
          >
            预览
          </Button>
          {/* </Link> */}
        </>
      )}
      &nbsp;&nbsp;&nbsp;
      {!state.disabled && (
        <Button
          size="large"
          auto={false}
          loading={saving}
          disabled={state.disabled}
          onClick={() => {
            handleSave({ valid: false }).then((r) => {
              update((t) => {
                t.hasChange = false;
              });
            });
          }}
        >
          保存
        </Button>
      )}
      {step < 3 && (
        <>
          &nbsp;&nbsp;&nbsp;
          <Button
            size="large"
            auto={false}
            type="hollow"
            loading={saving}
            onClick={() => {
              if (state.isViewType || state.hasSubmit) {
                return setStep(step + 1);
              }
              handleSave({ valid: false }).then((r) => {
                setStep(step + 1);
              });
            }}
          >
            下一页
          </Button>
        </>
      )}
      &nbsp;&nbsp;&nbsp;
      {step === 3 && !state.disabled && (
        <Button
          size="large"
          auto={false}
          style={{ width: '138px' }}
          loading={saving}
          disabled={state.disabled}
          onClick={() => {
            handleSave({ valid: true, tip: false }).then((r) => {
              Modal.confirm({
                title: <div>确认提交此项目?</div>,
                children: (
                  <div>
                    <p>项目提交后您将无法进行任何更改，请谨慎操作。项目办公室将向您发送形式审查结果。如进入答辩环节，项目办公室将根据您所填写的联系方式与您联系。最终结果将通过首页基金动态发布，敬请关注，感谢您的参与！</p>
                  </div>
                ),
                onConfirm: (e) => {
                  function cb(r) {
                    if (r.data?.code !== 0) {
                      toastTip.open({ title: '提交失败', content: r.data.message, status: 'fail' });
                    } else {
                      toastTip.open({
                        title: '提交成功',
                        content: r.data.message,
                        status: 'success',
                      });
                      update((t) => {
                        t.onSubmit = true;
                        t.hasSubmit = true;
                      });
                    }
                  }
                  const formType = state.formType;
                  if (formType === 'scientist') {
                    const {
                      researchOverview: {
                        achievement, contribution, futurePlan, progress, fillInType,
                      },
                    } = state.values || { researchOverview: {} };
                    if (fillInType === 'onlineFillIn') {
                      //处理申报时文本编辑器提交空白的内容能申报成功的异常
                      const editorContentRegExp = /(<(p|li|h2|h3|h4)>(?!<br\/?>)[\s\S]*?<\/(p|li|h2|h3|h4)>)/g;
                      if (editorContentIsEmpty(achievement)) return toastTip.open({ title: '提交失败', content: '科研及学术成就介绍不能为空。', status: 'fail' });
                      if (editorContentIsEmpty(progress)) return toastTip.open({ title: '提交失败', content: '在研科研项目及学术进展不能为空。', status: 'fail' });
                      if (editorContentIsEmpty(futurePlan)) return toastTip.open({ title: '提交失败', content: '未来五年科研工作规划不能为空。', status: 'fail' });
                      if (editorContentIsEmpty(contribution)) return toastTip.open({ title: '提交失败', content: '个人研究方向对相关议题研究的贡献和价值不能为空。', status: 'fail' });
                    }
                  }
                  update((t) => (t.saving = true));
                  handleSave({ valid: false, tip: false }).then((r) => {
                    if (formType === 'scientist') {
                      submitScientist({})
                        .then(cb)
                        .finally(() => {
                          update((t) => {
                            t.saving = false;
                          });
                        });
                    } else {
                      submitInnovate({})
                        .then(cb)
                        .finally(() => {
                          update((t) => {
                            t.saving = false;
                          });
                        });
                    }
                  });
                },
              });
            });
          }}
        >
          确认无误，提交
        </Button>
      )}
    </div>
  );
}
